import en from './json/en.json';

const languages = {
  en,
};

const preLoadedLanguages = Object.keys(languages);

export {
  languages,
  preLoadedLanguages,
};
